import React, {useState, useRef, useEffect} from "react";
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import axios from "axios";
import {Dialog} from "primereact/dialog";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {InputTextarea} from "primereact/inputtextarea";
import {Card} from 'primereact/card';
import {Toast} from "primereact/toast";
import connect from "react-redux/lib/connect/connect";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";


const CmsCategory = props => {

    const toast = useRef(null);
    const [categoryTypeList, setCategoryTypeList] = useState([]);
    const [expandedRows, setExpandedRows] = useState(null);
    const [cccID, setCccID] = useState('');
    const [cccName, setCccName] = useState('');
    const [cccDetail, setCccDetail] = useState('');
    const [categoryDeleteDialog, setCategoryDeleteDialog] = useState(false);
    const [cleanButtonAdd, setCleanButtonAdd] = useState('block');
    const [categoryId, setCategoryId] = useState(null);
    const [categoryDialog, setCategoryDialog] = useState(false);
    const [selectedcategoryID, setSelectedcategoryID] = useState(null);
    const category_add_role = !!localStorage.getItem('category_list');
    const category_add = !!localStorage.getItem('category_add');
    const [loadingState, setLoadingState] = useState(false)


    useEffect(() => {

        getCategory()
    }, []);


    const getCategory = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.get('api/content/type/list/', {"headers": headers})
            .then(res => {
                setCategoryTypeList(res.data)
            })
    }


    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }
    const submit = () => {
        setCategoryDialog(false)
        const obj = {
            ccc_id: cccID,
            ccc_name: cccName,
            ccc_detail: cccDetail,
            ctyp_id: selectedcategoryID,

        };
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;
            const body = JSON.stringify(obj);
            if (cccID) {
                fetch("/api/category" + "/" + cccID + "/", {headers, method: "PUT", body})
                    .then(res => {
                        if (res.status < 500) {
                            setLoadingState(false)
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            setLoadingState(false)
                            const data = res.data;

                            if (data.result) {
                                getCategory();

                                showSuccess(data.message);
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            setLoadingState(false);
                            throw res.data;
                        }
                    })
            } else {
                headers["Authorization"] = `Token ${token}`;
                const body = JSON.stringify(obj);
                fetch("/api/category/", {headers, method: "POST", body})
                    .then(res => {
                        if (res.status < 500) {
                            setLoadingState(false)
                            return res.json().then(data => {
                                return {status: res.status, data};
                            })
                        } else {
                            //console.log("Server Error!");
                            throw res;
                        }
                    })
                    .then(res => {
                        if (res.status === 200) {
                            setLoadingState(false)
                            const data = res.data;
                            if (data.result) {
                                getCategory();

                                showSuccess(data.message);
                                // setData(data.result)
                            } else {
                                showError(data.message);
                                // this.setState({disable_submit_btn: false});
                            }
                        } else if (res.status === 401) {
                            props.loadUser();
                            setLoadingState(false);
                            throw res.data;

                        } else if (res.status === 403) {
                            setLoadingState(false);
                            throw res.data;

                        }
                    })


            }
        }

        setCccDetail('')
        setCccID('')
        setCccName('')
        setCategoryId('')


    }

    const renderFooter = () => {
        return (
            <div>

                <Button label="Hayır" icon="pi pi-times" onClick={() => setCategoryDeleteDialog(false)}
                        className="p-button-text"/>
                <Button label="Evet" icon="pi pi-check" onClick={() => deleteCip(categoryId)} autoFocus/>
            </div>
        );
    }
    const editRow = (cccID, cccName, cccDetail) => {
        setCccID(cccID)
        setCccName(cccName)
        setCccDetail(cccDetail)
        setCleanButtonAdd('block')
        setCategoryDialog(true)

    }


    const deleteRow = (cccID) => {


        setCategoryDeleteDialog(true)
        setCategoryId(cccID)


    }
    const deleteCip = (cccID) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        axios.delete('api/category' + `/${cccID}/`, {"headers": headers})
            .then(res => {
                const data = res.data
                if (data.result) {

                    showSuccess(data.message);
                    // setData(data.result)
                } else {
                    showError(data.message);
                    // this.setState({disable_submit_btn: false});
                }


                getCategory();

                setCategoryDeleteDialog(false)
                setCategoryId(null)

            });


    };
    const actionTemplate = (rowData) => {
        //    // (rowData['cip_id'])
        return <div>


            <Button
                type="submit"
                title="Düzenle"
                icon="pi pi-pencil"
                className="p-button-warning p-mr-2"
                onClick={() => editRow(rowData['ccc_id'], rowData['ccc_name'], rowData['ccc_detail'])}
                style={{maxHeight: '2em', maxWidth: '2em',display: category_add ? 'block' : 'none'}}
            >
            </Button>
            <Button
                type="submit"
                title="Sil"
                icon="pi pi-trash"
                className="p-button-danger"
                onClick={() => deleteRow(rowData['ccc_id'])}
                style={{maxHeight: '2em', maxWidth: '2em',display: category_add ? 'block' : 'none'}}
            >
            </Button>


        </div>;
    }


    let category_table_header = (

        <div style={{'textAlign': 'center'}}>
            <h5><b>İçerik Türleri ve Kategoriler </b> &nbsp;&nbsp;</h5>

        </div>


    );
    const selectID = (ctyp_id) => {
        setCategoryDialog(true)
        setSelectedcategoryID(ctyp_id)
        // (ctyp_id)
    }


    const rowExpansionTemplate = (categoryTypeList) => {
        const content_category = categoryTypeList.content_category

        const header2 = (
            <div style={{'textAlign': 'center'}}>
                Kategoriler &nbsp;&nbsp;
                <Button icon="pi pi-plus-circle"
                        title="Kategori Ekle"
                        className="p-button-info"
                        style={{display: category_add ? 'block' : 'none'}}
                        onClick={() => selectID(categoryTypeList.ctyp_id)}
                />
            </div>


        );
        return (
            <div className="orders-subtable">
                <Toast ref={toast}/>

                <DataTable value={content_category} header={header2} emptyMessage="Kayıt bulunamadı">
                    <Column
                        header="İşlevler"
                        body={actionTemplate}
                    />
                    <Column field="ccc_id" header="No" sortable style={{textAlign: 'center'}}>

                    </Column>
                    <Column field="ccc_name" header="Ad" sortable style={{textAlign: 'center'}}>

                    </Column>
                    <Column field="ccc_detail" header="Detay" sortable style={{textAlign: 'center'}}>

                    </Column>
                </DataTable>
            </div>
        );
    }

    if (category_add_role) {

        return (
            <div className="container d-flex h-100">


                <Card className="p-card-content">
                    <Dialog header="UYARI" visible={categoryDeleteDialog}
                            style={{width: '20%'}}
                            footer={renderFooter()}

                            onHide={() => setCategoryDeleteDialog(false)}>
                        <div className="confirmation-content">
                            <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                            <span>Silmek İstediğinizden Emin Misiniz?</span>
                        </div>


                    </Dialog>


                    <div className="content-section implementation">

                        <DataTable
                            dataKey="ctyp_id"
                            value={categoryTypeList}
                            rowExpansionTemplate={rowExpansionTemplate}
                            expandedRows={expandedRows}
                            onRowToggle={(e) => setExpandedRows(e.data)}
                            selectionMode="single"
                            emptyMessage="Kayıt bulunamadı"
                            paginator={true}
                            resizableColumns={true}
                            rows={20}
                            responsive={true}
                            header={category_table_header}
                        >
                            <Column expander style={{width: '3em'}}/>
                            <Column field="ctyp_id" header="No" sortable
                                    style={{textAlign: 'center'}}/>
                            <Column field="ctype_code" header="Ad" sortable filter={true}
                                    style={{textAlign: 'center'}}/>
                            <Column field="ctyp_name" header="Açıklama" sortable filter={true}
                                    style={{textAlign: 'center'}}/>

                        </DataTable>
                        <Dialog header="Kategori Ekle"
                                visible={categoryDialog}
                                style={{width: '40vw'}}

                                onHide={() => setCategoryDialog(false)} maximizable>
                            <div className="p-grid">


                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input">Ad
                                    </label>
                                    <span style={{color: "red"}}> (*)</span>
                                </div>
                                <div className="p-col-12 p-md-10 p-lg-10">
                                    <InputText
                                        value={cccName}

                                        onChange={(e) => setCccName(e.target.value)}
                                        style={{width: '80%'}}
                                        placeholder="Ad Giriniz"
                                        required/>
                                </div>
                                <div className="p-col-12 p-md-2">
                                    <label htmlFor="input"> Açıklama
                                    </label>
                                    <span style={{color: "red"}}> (*)</span>
                                </div>
                                <div className="p-col-12 p-md-10 p-lg-10">
                                    <InputTextarea
                                        value={cccDetail}

                                        onChange={(e) => setCccDetail(e.target.value)}
                                        placeholder="Açıklama Giriniz"
                                        style={{width: '80%'}}
                                        rows={4}
                                        cols={30}
                                        required/>
                                </div>


                                <div className="p-col-12 p-md-10 p-lg-12" align="right">
                                    <Button label="Ekle" icon="pi pi-check" iconPos="left" style={{
                                        display: {cleanButtonAdd},
                                        width: '150px',
                                        background: 'deepskyblue',
                                        top: '10px'
                                    }}

                                            onClick={() => submit()}
                                    /></div>


                            </div>


                        </Dialog>

                    </div>
                </Card>
            </div>
        )
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }

}
const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CmsCategory);



// WEBPACK FOOTER //
// ./src/pages/cmsmanagement/CmsCategory.jsx